import { Action } from 'redux';

import { UpdateAlertTotal } from './AppActionTypes';
import { isActionFactory } from './isActionFactory';

export interface UpdateAlertTotalAction extends Action {
  total: number;
}

export function updateAlertTotalAction(total: number): UpdateAlertTotalAction {
  return {
    type: UpdateAlertTotal,
    total: total
  };
}

export const isUpdateAlertTotalAction = isActionFactory<UpdateAlertTotalAction>(UpdateAlertTotal);
